import { createSlice } from '@reduxjs/toolkit';
import { getDefaultView } from '@/pages/reports/non-ats-reports/shared/utils/date-group';
import { formatLocalDate } from '@/utils/dateUtils';

export const getDefaultAtsFilters = () => ({
  time: {
    date_group: 'Q',
    from: 'past12m',
    to: null,
  },

  filters: {},
  filterWithvalues: [],
  drilldown: {},
  group: {
    group_by_1: null,
    group_by_2: null,
  },
  searchTerm: null,
});

export const buildReportsSlice = ({
  name,
  initialState = {},
  extraReducers = {},
  reducers = {},
}) => {
  return createSlice({
    name,
    initialState,
    reducers: {
      applyFilter: (state, { payload }) => {
        state.filters = payload;
      },

      setFiltersData: (state, { payload }) => {
        state.filterWithvalues = payload;
      },

      resetFilter: (state) => {
        state.filters = {};
      },

      applyGroup: (state, { payload }) => {
        const { key, value } = payload;
        state.group = { ...state.group, [key]: value };
      },

      resetDrillDown: (state, { payload }) => {
        if (payload?.keepSearchTerm !== true) {
          state.searchTerm = null;
        }
        state.currentDrillPage = 1;
        state.drilldownData = [];
        state.totalCount = 0;
        state.initialLoading = false;
        state.isDrillLoading = false;
      },

      applySearch: (state, { payload }) => {
        state.searchTerm = payload?.searchTerm;
      },

      applyTimeFrame: (state, { payload = {} }) => {
        const { from, to } = payload;
        const dateGroupValue = getDefaultView(from, to);
        if (!to) {
          state.time = {
            ...state.time,
            from: from,
            to: null,
            date_group: dateGroupValue,
          };
          return;
        }

        state.time = {
          ...state.time,
          from: formatLocalDate(from),
          to: formatLocalDate(to),
          date_group: dateGroupValue,
        };
      },

      applyViewBy: (state, { payload = {} }) => {
        const { id } = payload;
        state.time = {
          ...state.time,
          date_group: id,
        };
      },

      applyDrillDown: (state, { payload = {} }) => {
        const metricMap = {
          'Application review': 'applied',
          Interviews: 'interviewed',
          Offer: 'offer',
          Hired: 'hired',
        };

        const metrics = metricMap[payload] || payload;

        state.drillDown = {
          metrics: metrics,
        };
      },
      ...reducers,
    },
    extraReducers,
  });
};
